export const defaultStyle = {
  navContainer:
    "navContainer lg:pl-[59px] relative lg:flex text-left items-center navUl md:gap-[16px] lg:gap-[26px] left-[27px] transition delay-150 duration-500 ease-in-out before:text-[11px] mr-[27px] lg:mr-[45px]",
}

export const ENG_HEADER_NEW = {
  ...defaultStyle,
  navLink: 'navLink text-left font-MDLZBiteType text-[18px] md:leading-[1.5] font-normal text-gray',
  navContainer: "navContainer relative lg:flex text-center items-center navUl md:gap-[16px] lg:gap-[26px] left-[27px] transition delay-150 duration-500 ease-in-out before:text-[11px] mr-[27px] lg:mr-[45px]",
}
